import AiMarkdown from "../AiMarkdown";
import LanguageDropdown from "../../common/LanguageDropdown";

const QuizOption = ({
  index,
  option,
  state,
  onSelect,
  disabled,
  readOnly = false,
}) => {
  const className = `ai-quiz-option ai-quiz-option--${state}${
    readOnly ? " ai-quiz-option--readonly" : ""
  }`;
  const content = (
    <>
      <span className="ai-quiz-option-index" aria-hidden="true">
        {index}
      </span>
      <span className="ai-quiz-option-text">{option.text}</span>
    </>
  );

  // History / review: non-button so mobile sticky :hover and taps can't "select"
  if (readOnly) {
    return (
      <div className={className} role="listitem">
        {content}
      </div>
    );
  }

  return (
    <button
      type="button"
      className={className}
      onClick={() => onSelect(option.option_id)}
      disabled={disabled}
      aria-pressed={
        state === "selected" || state === "correct" || state === "incorrect"
      }
    >
      {content}
    </button>
  );
};

const QuizQuestion = ({
  question,
  optionState,
  onSelectOption,
  isChecked,
  languageCode,
  onLanguageChange,
  languageLabel,
  canCheck,
  onCheckAnswer,
  checkLabel,
  explanationLabel,
  progressLabel,
  answerOptionsLabel,
}) => {
  if (!question) return null;

  return (
    <div className="ai-quiz-body">
      <div className="ai-quiz-toolbar">
        {progressLabel ? (
          <p className="ai-quiz-progress ai-quiz-progress--toolbar">
            {progressLabel}
          </p>
        ) : (
          <LanguageDropdown
            value={languageCode}
            onChange={onLanguageChange}
            ariaLabel={languageLabel}
            className="ai-quiz-language"
            align="start"
          />
        )}

        <button
          type="button"
          className={`ai-quiz-check${canCheck ? " is-ready" : ""}`}
          onClick={onCheckAnswer}
          disabled={!canCheck}
        >
          {checkLabel}
        </button>
      </div>

      <div className="ai-quiz-question-panel">
        <p className="ai-quiz-question-text">{question.question_text}</p>

        <div
          className="ai-quiz-options"
          role="listbox"
          aria-label={answerOptionsLabel}
        >
          {question.options.map((option, index) => (
            <QuizOption
              key={option.option_id}
              index={index + 1}
              option={option}
              state={optionState[option.option_id] || "default"}
              onSelect={onSelectOption}
              disabled={isChecked}
            />
          ))}
        </div>

        {isChecked && question.explanation && (
          <div className="ai-quiz-explanation" role="status">
            <strong>{explanationLabel}</strong>
            <AiMarkdown>{question.explanation}</AiMarkdown>
          </div>
        )}
      </div>
    </div>
  );
};

export default QuizQuestion;
export { QuizOption };
